export default __webpack_public_path__ + "static/media/Order-Sign-picture.37015446.jpg";